import { attach, createEffect } from 'effector';
import { HiveTheme } from 'model/domain';
import { parentNode$ } from 'model/mount.model';

export const themeVars = {
	background: '--background',
	primaryColor: '--primary-color',
	secondaryColor: '--secondary-color',
	buttonPrimaryHover: '--button-primary-hover',
	buttonPrimaryText: '--button-primary-text',
	buttonOutlineText: '--button-outline-text',
	buttonOutlineBorder: '--button-outline-border',
	textPrimary: '--text-primary',
	textSecondary: '--text-secondary',
	textTertiary: '--text-tertiary',
	whitelabelHover: '--whitelabel-hover',
	barcodeLight: '--barcode-light',
	QRCodeColor: '--barcode-dark',
	inputIcon: '--input-icon',
	inputText: '--input-text',
	inputBorder: '--input-border',
	inputPlaceholder: '--input-placeholder',
	inputHover: '--input-hover',
	whitelabelHoverText: '--whitelabel-hover-text',
	successPrimary: '--success-primary',
	successSecondary: '--success-secondary',
	errorPrimary: '--error-primary',
	errorSecondary: '--error-secondary',
};

export type Theme = typeof themeVars;

export const defaultTheme: Theme = {
	background: '#ffffff',
	primaryColor: '#6E37D8',
	secondaryColor: '#DFCFF8',
	buttonPrimaryHover: '#5426AB',
	buttonPrimaryText: '#ffffff',
	buttonOutlineText: '#262626',
	buttonOutlineBorder: '#D9D9D9',
	textPrimary: '#262626',
	textSecondary: '#595959',
	textTertiary: '#8C8C8C',
	whitelabelHover: '#F4F5F7',
	whitelabelHoverText: '#262626',
	barcodeLight: '#ffffff',
	QRCodeColor: '#000000',
	inputIcon: '#8C8C8C',
	inputText: '#262626',
	inputBorder: '#D9D9D9',
	inputPlaceholder: '#BFBFBF',
	inputHover: '#f5f5f5',
	successPrimary: '#389E0D',
	successSecondary: '#CBF4C9',
	errorPrimary: '#FF4D4F',
	errorSecondary: '#CF1322',
};

const allowKeys = ['primaryColor', 'secondaryColor', 'buttonPrimaryHover', 'buttonPrimaryText', 'QRCodeColor'];

export const applyThemeFx = createEffect({
	handler: (payload: { theme: Theme, parentNode: HTMLElement }) => {
		if (!payload.parentNode) {
			throw new Error('SDK Container not found');
		}

		const themeContainer = payload.parentNode
			.querySelector(`[data-verify-container='true']`) as HTMLDivElement;

		if (!themeContainer) {
			throw new Error('SDK Container not found');
		}

		for (const key in payload.theme) {
			if (allowKeys.includes(key)) {
				themeContainer.style.setProperty(themeVars[key], payload.theme[key]);
			}
		}
	},
});

export const applyInitialTheme = attach({
	source: { parentNode: parentNode$ },
	effect: applyThemeFx,
	mapParams: (payload: { paramsTheme: Partial<HiveTheme>, dashTheme: Partial<HiveTheme> }, source) => {
		const theme = {
			...defaultTheme,
			...payload.dashTheme,
			...payload.paramsTheme,
		};
		console.log(theme);

		return {
			parentNode: source.parentNode,
			theme,
		};
	},
});

export const updateThemeFx = attach({
	source: { parentNode: parentNode$ },
	effect: applyThemeFx,
	mapParams: (payload: { theme: Theme }, source) => ({
		parentNode: source.parentNode,
		theme: payload.theme,
	}),
});
